export const ApiRoutes = {
  website: {
    get: '/website/getWebsite',
    view: '/website/view',
  },
};
